module.exports = __webpack_public_path__ + "static/img/news_51.7c4a3c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_51.jpg
// module id = by0q
// module chunks = 2